import { useEffect, useState } from 'react';
import * as S from './Table.styled';
import { Button, Popconfirm, Table as TableAnt } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { TablePaginationConfig } from 'antd/lib/table/interface';
import { IOrganization } from 'interfaces/main';
import type { FilterValue, SortOrder, SorterResult } from 'antd/es/table/interface';
import { JSX } from 'react/jsx-runtime';

interface TableParams {
	pagination?: TablePaginationConfig;
	sortField?: string;
	sortOrder?: SortOrder;
	filters?: Record<string, FilterValue>;
}

export interface Props {
	items: IOrganization[];
	isDisabled: boolean;
	onEdit(lotId: number): void;
	onRemove(lotId: number): void;
}

const Table = ({ items, isDisabled, onEdit, onRemove }: Props): JSX.Element => {
	// Table params
	const [tableParams, setTableParams] = useState<TableParams>({
		pagination: {
			current: 1,
			pageSize: 10,
			total: 0,
		},
		sortField: 'title',
		sortOrder: 'descend',
	});

	useEffect(
		() =>
			setTableParams({
				...tableParams,
				pagination: {
					...tableParams.pagination,
					total: items.length,
				},
			}),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[items],
	);

	// const emails = uniq(items.map((item: ILot) => item.)).map(
	//   (email: string) => ({ text: email, value: email })
	// );

	// const phones = uniq(items.map((item: ILot) => item.phone)).map(
	//   (phone: string) => ({ text: phone, value: phone })
	// );

	// const names = uniq(items.map((item: ILot) => item.name)).map(
	//   (name: string) => ({ text: name, value: name })
	// );

	// Конфиг таблички для Ant Table
	const columns: ColumnsType<IOrganization> = [
		{
			title: 'Title',
			dataIndex: 'title',
			key: 'title',
			sorter: (a: IOrganization, b: IOrganization) => {
				if (a.title < b.title) {
					return -1;
				}
				if (a.title > b.title) {
					return 1;
				}
				return 0;
			},
			defaultSortOrder: 'ascend',
		},
		{
			title: 'Description',
			dataIndex: 'description_en',
			key: 'description_en',
			ellipsis: true,
			render: (description: string) => description || '-',
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email',
			ellipsis: true,
			render: (email: string) => email || '-',
		},
		{
			title: 'Phone',
			dataIndex: 'phone',
			key: 'phone',
			render: (phone: string) => phone || '-',
		},
		{
			title: 'Site',
			dataIndex: 'site',
			key: 'site',
			ellipsis: true,
			render: (site: string) => site || '-',
		},
		{
			title: '',
			key: 'action',
			render: (_: string, organization: IOrganization) => {
				return (
					<S.Actions>
						<Button onClick={() => onEdit(organization.id)} size="small" disabled={isDisabled}>
							edit
						</Button>
						<Popconfirm
							placement="rightBottom"
							title="Are you sure to delete this organization?"
							onConfirm={() => onRemove(organization.id)}
							okText="delete"
							cancelText="cancel"
							disabled={isDisabled}>
							<Button size="small" disabled={isDisabled}>
								delete
							</Button>
						</Popconfirm>
					</S.Actions>
				);
			},
		},
	];

	const handleTableChange = (
		pagination: TablePaginationConfig,
		filters: Record<string, FilterValue>,
		sorter: SorterResult<IOrganization>,
	) => {
		setTableParams({
			pagination,
			filters,
			...sorter,
		});
	};

	return (
		<S.Wrap>
			<TableAnt
				columns={columns}
				rowKey={(organization: IOrganization) => organization.id}
				dataSource={items}
				pagination={false}
				onChange={handleTableChange}
			/>
		</S.Wrap>
	);
};

export default Table;
